import React from "react";
import DropdownSchoolYear from "../../../../unicomponents/Dropdowns/DropdownSchoolYear";
import DropdownHierarchyOne from "../../../../unicomponents/Dropdowns/DropdownHierarchyOne";
import DropdownHierarchyTwo from "../../../../unicomponents/Dropdowns/DropdownHierarchyTwo";
import DropdownHierarchyThree from "../../../../unicomponents/Dropdowns/DropdownHierarchyThree";

export default function DropdownsForAttendanceStatistics({
  settingData,
  handleDropdownChange,
  organSettingInfo,
  selectedMonth,
  onChangeMonth,
  validYearMonths,
}) {
  return (
    <>
      <DropdownSchoolYear
        settingData={settingData}
        handleDropdownChange={handleDropdownChange}
        schoolYearId={organSettingInfo.schoolYearId}
        allYears={false}
      />
      <DropdownHierarchyOne
        settingData={settingData}
        handleDropdownChange={handleDropdownChange}
        schoolYear={organSettingInfo.schoolYear}
        hierarchyOneId={organSettingInfo.hierarchyOneId}
      />
      <DropdownHierarchyTwo
        settingData={settingData}
        handleDropdownChange={handleDropdownChange}
        schoolYear={organSettingInfo.schoolYear}
        hierarchyOneId={organSettingInfo.hierarchyOneId}
        hierarchyTwoId={organSettingInfo.hierarchyTwoId}
      />
      <DropdownHierarchyThree
        settingData={settingData}
        handleDropdownChange={handleDropdownChange}
        schoolYear={organSettingInfo.schoolYear}
        hierarchyTwoId={organSettingInfo.hierarchyTwoId}
        hierarchyThreeId={organSettingInfo.hierarchyThreeId}
      />
      {/* 년-월 드롭다운: "24-2월" 형식으로 표시 */}
      <select
        className="form-control"
        value={selectedMonth}
        name="yearMonth"
        onChange={onChangeMonth}
      >
        {validYearMonths &&
          validYearMonths.map((ym) => (
            <option key={ym.yearMonth} value={ym.yearMonth}>
              {String(ym.year).slice(2)}-{ym.month}월
            </option>
          ))}
      </select>
    </>
  );
}
